import {makeStyles} from "@mui/styles";

const withStyles = makeStyles(theme => ({
    addBtn: {
        backgroundColor: theme.palette.secondary.dark
    }
}));

export default withStyles;